import axiosConfig from "../config/axios";

export const getPredefinedRoutes = async (params = {}) => {
  const { data } = await axiosConfig.get("/predefined-routes", {
    params,
  });

  return data;
};

export const getPredefinedRouteById = async (id) => {
  const { data } = await axiosConfig.get(`/predefined-routes/${id}`);
  return data;
};

export const createPredefinedRoute = async (payload) => {
  const { data } = await axiosConfig.post("/predefined-routes", payload);
  return data;
};

export const updatePredefinedRoute = async (id, payload) => {
  const { data } = await axiosConfig.put(`/predefined-routes/${id}`, payload);
  return data;
};

export const deletePredefinedRoute = async (id) => {
  const { status } = await axiosConfig.delete(`/predefined-routes/${id}`);
  return status;
};